"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDivDimensions(str, addStyles) {
    var div = document.createElement("div");
    div.innerText = str;
    div.style.visibility = "none";
    div.style.position = "absolute";
    addStyles === null || addStyles === void 0 ? void 0 : addStyles(div);
    document.body.appendChild(div);
    var _a = div.getBoundingClientRect(), height = _a.height, width = _a.width;
    document.body.removeChild(div);
    return [width, height];
}
exports.default = getDivDimensions;
//# sourceMappingURL=index.js.map